export default "/images/targeting-icon-a.svg?eb8ed3aaf0ab2caf5a6d33b5cf3517fa";